























import Vue from "vue";
import { Component, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import './winners-categories.less';
import {getWinnerCategoryData} from "@/services/getNomineeData/getNomineeData";


@Component({
  components: {
  }
})
export default class winnersCategories extends Vue {
  private categoriesData :{ id: number, image: string, title: string, url: string }[]= [];

  mounted() {
    this.categoriesData = getWinnerCategoryData();
  }

  trans(key) {
    return translate(key);
  }
  selectCategory(categoryId){
    this.onSelectCategory(categoryId);
    history.pushState('', '', this.categoriesData[categoryId-1].url);
  }

  @Emit("selectCategory")
  onSelectCategory(categoryId) {
  }
}
